import React from "react";

export default function DisplayAccessibility() {
  return (
    <div className="absolute_wrap">
      <div className="mmenu_main">
        <div className="small_circle" style={{ width: "50px" }}>
          <i className="dark_filled_icon"></i>
        </div>
        <div className="mmenu_col">
          <span className="mmenu_span1">Display</span>
          <span className="mmenu_span2">
            Adjust accessibility settings for contrast and readability.
          </span>
        </div>
      </div>
      <div style={{ marginTop: 8, color: '#555' }}>
        Dark mode support has been removed. Use your system settings or browser extensions if you need alternate color schemes.
      </div>
    </div>
  );
}
